import { useState } from 'react'
import { Link } from 'react-router-dom'
import { supabase } from '../lib/supabaseClient'
import AuthLayout from '../components/AuthLayout'
import Input from '../components/Input'
import { useLanguage } from '../hooks/useLanguage'

export default function ForgotPassword() {
  const { t } = useLanguage()
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)

  function validate() {
    if (!email) return t('forgot_password_error_required')
    if (!/\S+@\S+\.\S+/.test(email)) return t('forgot_password_error_invalid')
    return ''
  }

  async function handleSubmit(e) {
    e.preventDefault()
    const err = validate()
    if (err) { setError(err); return }

    setLoading(true)
    setError('')

    const { error: sbError } = await supabase.auth.resetPasswordForEmail(email, {
      // Supabase redirigirá aquí tras hacer clic en el email
      redirectTo: `${window.location.origin}/reset-password`,
    })

    setLoading(false)

    if (sbError) {
      // Supabase no revela si el correo existe o no por seguridad,
      // pero igual mostramos el estado de éxito para no revelar usuarios
      if (sbError.message.toLowerCase().includes('rate limit')) {
        setError(t('forgot_password_error_rate_limit'))
        return
      }
    }

    // Siempre mostramos "enviado" aunque el correo no exista (buena práctica de seguridad)
    setSent(true)
  }

  if (sent) {
    return (
      <AuthLayout>
        <div style={{ textAlign: 'center', padding: '8px 0' }}>
          {/* Ícono de sobre */}
          <div style={{
            width: 64, height: 64,
            background: 'rgba(22,163,74,0.1)',
            borderRadius: '50%',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 20px',
            fontSize: 28,
          }}>
            📬
          </div>

          <h2 style={{
            fontFamily: 'var(--font-display)',
            fontSize: 22, fontWeight: 600,
            marginBottom: 10, color: 'var(--color-text)',
          }}>
            {t('forgot_password_sent_title')}
          </h2>

          <p style={{ fontSize: 14, color: 'var(--color-muted)', lineHeight: 1.6, marginBottom: 8 }}>
            {t('forgot_password_sent_desc').split('{email}')[0]}
            <strong style={{ color: 'var(--color-text)' }}>{email}</strong>
            {t('forgot_password_sent_desc').split('{email}')[1]}
          </p>

          <p style={{ fontSize: 13, color: 'var(--color-muted)', lineHeight: 1.6, marginBottom: 24 }}>
            {t('forgot_password_sent_expire').split('{time}')[0]}
            <strong style={{ color: 'var(--color-text)' }}>{t('forgot_password_expire_time')}</strong>
            {t('forgot_password_sent_expire').split('{time}')[1]}
          </p>

          {/* Separador */}
          <div style={{
            borderTop: '1px solid var(--color-border)',
            paddingTop: 20, marginTop: 4,
          }}>
            <p style={{ fontSize: 13, color: 'var(--color-muted)', marginBottom: 12 }}>
              {t('forgot_password_no_email')}
            </p>
            <button
              onClick={() => setSent(false)}
              style={{
                background: 'none',
                color: '#ffffff',
                fontSize: 14, fontWeight: 600,
                padding: 0, cursor: 'pointer',
                textDecoration: 'underline',
              }}
            >
              {t('forgot_password_try_another')}
            </button>
          </div>
        </div>

        <div style={{
          marginTop: 22, paddingTop: 20,
          borderTop: '1px solid var(--color-border)',
          textAlign: 'center', fontSize: 14, color: 'var(--color-muted)',
        }}>
          <Link to="/login" style={{ fontWeight: 600 }}>{t('forgot_password_back_login')}</Link>
        </div>
      </AuthLayout>
    )
  }

  return (
    <AuthLayout>
      <h2 style={{
        fontFamily: 'var(--font-display)',
        fontSize: 22, fontWeight: 600, marginBottom: 6,
      }}>
        {t('forgot_password_title')}
      </h2>
      <p style={{ fontSize: 14, color: 'var(--color-muted)', marginBottom: 24, lineHeight: 1.5 }}>
        {t('forgot_password_desc')}
      </p>

      <form onSubmit={handleSubmit} noValidate style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <Input
          label={t('forgot_password_email_label')}
          type="email"
          value={email}
          onChange={(e) => { setEmail(e.target.value); setError('') }}
          placeholder={t('forgot_password_email_placeholder')}
          error={error}
          required
          autoComplete="email"
        />

        <button
          type="submit"
          disabled={loading}
          style={{
            marginTop: 4, padding: '13px',
            background: loading ? '#86efac' : 'var(--color-primary)',
            color: '#fff', fontSize: 15, fontWeight: 600,
            borderRadius: 'var(--radius-sm)', boxShadow: 'var(--shadow-btn)',
            transition: 'background var(--transition)',
          }}
          onMouseEnter={(e) => { if (!loading) e.target.style.background = 'var(--color-primary-h)' }}
          onMouseLeave={(e) => { if (!loading) e.target.style.background = 'var(--color-primary)' }}
        >
          {loading ? t('forgot_password_sending') : t('forgot_password_send_btn')}
        </button>
      </form>

      <div style={{
        marginTop: 22, paddingTop: 20,
        borderTop: '1px solid var(--color-border)',
        textAlign: 'center', fontSize: 14, color: 'var(--color-muted)',
      }}>
        <Link to="/login" style={{ fontWeight: 600 }}>{t('forgot_password_back_login')}</Link>
      </div>
    </AuthLayout>
  )
}